import React from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { NAV_ITEMS } from '../data/content';
import { CTAButton } from './CTAButton';
import { Logo } from './Logo';
export function Header() {
  const [open, setOpen] = React.useState(false);
  const [solid, setSolid] = React.useState(false);
  React.useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > 80);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const linkTone = solid ? 'text-ink-500 hover:text-brand-600' : 'text-white/80 hover:text-white';
  return <header className={`fixed inset-x-0 top-0 z-50 transition-[background-color,box-shadow,border-color] duration-300 ease-expo ${solid ? 'border-b border-line bg-white/90 shadow-[0_10px_30px_-24px_rgba(10,16,32,0.4)] backdrop-blur-xl' : 'border-b border-white/10 bg-transparent'}`} data-id="element-83" data-mp="36bbfpcpywik9">
      <div className="mx-auto flex h-16 max-w-[1400px] items-center justify-between px-5 sm:h-[76px] lg:px-8" data-id="element-84" data-mp="2wmfhqlt2l657">
        <a href="#top" aria-label="Elyon Markets — inicio" data-id="element-85" data-mp="2rkgerd18sb8s">
          <Logo tone={solid ? 'dark' : 'light'} data-id="element-86" data-mp="2mlvghj5jw1mz" />
        </a>

        <nav aria-label="Principal" className="hidden lg:block" data-id="element-87" data-mp="2hnlhsykmaiwm">
          <ul className="flex items-center gap-9" data-id="element-88" data-mp="2hp51kz5hfc35">
            {NAV_ITEMS.map(item => <li key={item.href} data-id="element-89" data-mp="3fasvndegtibi">
                <a href={item.href} className={`text-[14px] font-medium transition-colors duration-200 ease-expo ${linkTone}`} data-id="element-90" data-mp="3ac97r7gb9wgi">
                  {item.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <div className="flex items-center gap-2.5" data-id="element-91" data-mp="30klldkym35lw">
          <CTAButton label="Abrir cuenta" location="header" size="sm" variant={solid ? 'primary' : 'onDark'} className="hidden sm:inline-flex" data-id="element-92" data-mp="1xhcfpwpmnuw" />
          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? 'Cerrar menú' : 'Abrir menú'} className={`grid h-10 w-10 place-items-center rounded-xl border transition-colors duration-200 ease-expo lg:hidden ${solid ? 'border-line text-ink-900 hover:border-brand-200' : 'border-white/25 text-white hover:border-white/50'}`} data-id="element-93" data-mp="1re38k23sr4j1">
            {open ? <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-94" data-mp="ypfjrwju9x0q" /> : <MenuIcon className="h-5 w-5" aria-hidden="true" data-id="element-95" data-mp="13nz0nijksim8" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-96" data-mp="2t2nfrrjjweny">
        {open && <motion.nav id="mobile-nav" aria-label="Menú móvil" initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} className="overflow-hidden border-t border-line bg-white lg:hidden" data-id="element-97" data-mp="2t3q9064cit71">
            <ul className="space-y-1 px-5 py-4" data-id="element-98" data-mp="w5slo77lp4hu">
              {NAV_ITEMS.map(item => <li key={item.href} data-id="element-99" data-mp="rc6e2tganqsw">
                  <a href={item.href} onClick={() => setOpen(false)} className="block rounded-xl px-3 py-3 text-[15px] font-medium text-ink-700 transition-colors duration-200 ease-expo hover:bg-brand-50 hover:text-brand-600" data-id="element-100" data-mp="1555ucxnwhp1i">
                    {item.label}
                  </a>
                </li>)}
              <li className="pt-2" data-id="element-101" data-mp="3gup164bod32f">
                <CTAButton label="Abrir cuenta" location="header_mobile" size="md" className="w-full" data-id="element-102" data-mp="3gvqc88soxpk5" />
              </li>
            </ul>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}